/**
 * The disposition payload the dialer sends for a call.
 *
 * Built in one place because two call sites send it — the state shared across
 * dialer windows, and the hangup request's fallback when that state has been
 * cleared. `set_disposition` re-runs the whole disposition from whichever body
 * reaches it, so a body missing `other_comment` rewrites a call the agent
 * filed as "other" into a plain disposition and leaves the comment stranded in
 * `info`.
 */
export function buildCallDispositionData({
  callSid,
  dispositionId,
  callNumber,
  dispositionComment,
  callbackDate,
  grantedConsent,
}) {
  const data = {
    call_sid: callSid,
    disposition_id: dispositionId,
    redial: false,
    callNumber,
  };
  if (dispositionComment) {
    data.other_comment = dispositionComment;
  }
  if (callbackDate) {
    data.callback_time = callbackDate;
  }
  if (grantedConsent) {
    data.enable_recording = grantedConsent;
  }
  return data;
}
